import api from "@/api/apiConfig"
import {
  Post,
  Get,Put
} from './base/baseAjax'
let getTalents = (param) => {
  return Post({
    url: api.talents.getTalents,
    bodyParam: param
  })
}
let addTalents = (param) => {
  return Post({
    url: api.talents.addTalents,
    bodyParam: param
  })
}
let editTalents = (param) => {
  return Put({
    url: api.talents.editTalents,
    bodyParam: param
  })
}
let isRequired = (param) => {
  return Get({
    url: api.talents.isRequired,
    PathParam: param
  })
}


export default {
  getTalents,
  addTalents,
  editTalents,
  isRequired
}



// WEBPACK FOOTER //
// ./src/services/talents.js